import _get from "lodash/get";
import { css } from 'styled-components';
import typographyTheme from './typographyTheme';

var smallStyles = function smallStyles(_ref) {
  var theme = _ref.theme,
      colorValue = _ref.colorValue;
  return css(["color:", ";font-family:", ";font-size:", ";"], _get(theme, "typography.colors." + colorValue, typographyTheme.typography.colors[colorValue]), _get(theme, 'typography.base.fontFamily', typographyTheme.typography.base.fontFamily), _get(theme, 'typography.small.fontSize', typographyTheme.typography.small.fontSize));
};

export default smallStyles;